// extracted by mini-css-extract-plugin
export default {"pointer":"style_pointer__ioB2w","resize":"style_resize__rpCNc"};